/**
 * 头部导航
 */
export default {
  signIn: '로그인',
  signOut: '로그아웃',
}
